import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SitemapPage from "@/pages/SitemapPage";

export const Route = createFileRoute("/es/mapa-del-sitio")({
  head: () => buildRouteHead("/es/mapa-del-sitio"),
  component: SitemapPage,
});

